/** Site-wide company contact (Tampa office). */
export const COMPANY_EMAIL = 'breckenridgecapitalpartners@gmail.com';
export const COMPANY_EMAIL_HREF = `mailto:${COMPANY_EMAIL}`;

export const COMPANY_PHONE_DISPLAY = '804-413-1900';
export const COMPANY_PHONE_TEL = 'tel:+18044131900';

export const COMPANY_ADDRESS_LINE_1 = '5126 Net Drive';
export const COMPANY_ADDRESS_LINE_2 = 'Tampa, FL 33634';
export const COMPANY_ADDRESS_SINGLE = `${COMPANY_ADDRESS_LINE_1}, ${COMPANY_ADDRESS_LINE_2}`;

/** Open location in Google Maps (new tab). */
export const COMPANY_GOOGLE_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent(`${COMPANY_ADDRESS_LINE_1}, ${COMPANY_ADDRESS_LINE_2}`);

/**
 * Embedded map iframe (no API key). If this fails to render in your region,
 * replace with an embed from Google Maps → Share → Embed a map.
 */
export const COMPANY_MAP_EMBED_URL =
  'https://maps.google.com/maps?q=' +
  encodeURIComponent(COMPANY_ADDRESS_SINGLE) +
  '&hl=en&z=15&output=embed';
